import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  CoreFileLinkActions,
  CoreFileLinkState,
} from '@osos/shared/legacy-core';
import { FileModel } from '@osos/shared/types';

@Pipe({
  name: 'getLink',
  standalone: false,
})
export class FileLinkPipe implements PipeTransform {
  constructor(private store: Store) {}
  /**
   *
   * @param value FileModel | string, this will take two types to preserve the backward compatibility
   * for thumbnail that was string and changed to FileModel
   * @param args
   * @returns string file link
   */
  transform(value: FileModel | string, ...args: any[]): any {
    if (!value || typeof value === 'string') {
      return;
    }
    const fileId = value.id;
    this.store.dispatch(new CoreFileLinkActions.FetchFileLink(fileId));
    return this.store.select(CoreFileLinkState.presentedFileLink(fileId));
  }
}
